<!--一体化教研 - 一体化教研统计  -->
<template>
    <div class="stat-container">
        <div class="stat-scrollbar">
            <div class="border-container">
                <div class="flex-item school-title">
                   {{schoolName}}
                </div>
                <div class="flex-item school-content">师资及活动统计看板</div>
                <div class="flex-item school-sel" >
                    <el-select @change="statsFormChange" v-if="schoolList&&schoolList.length>1"
                               v-model="statsQueryForm.orgId"
                               filterable
                               style="width: 140px"
                               placeholder="请选择学校">
                        <el-option v-for="item in schoolList" :key="item.orgId" :label="item.orgName"
                                   :value="item.orgId" />
                    </el-select>
                </div>
            </div>
            <!--师资概况 -->
            <el-row :gutter="20"  style="text-align: left;width: 100%;height: 40px;" >
                <el-col :span="19"  style="height: 40px">
                    <div  style="padding-left: 10px;font-size: 18px;color: #333;font-weight: bold;">师资概况</div>
                </el-col>
                <el-col :span="5" style="height: 40px">
                </el-col>
            </el-row>
            <div style="padding-bottom: 10px">
                <el-row :gutter="20"  style="width: 100%">
                    <el-col :span="6" >
                        <el-card class="first-item" :body-style="{ padding: '10px' }">
                            <div class="stat-title">教师总数</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewTea(teaStats.teaList)">{{teaStats.teaCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card :body-style="{ padding: '10px' }">
                            <div class="stat-title">本科及以上学历占比</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewTea(teaStats.bkTeaList)">{{teaStats.bkTeaCountRate}}%</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card :body-style="{ padding: '10px' }">
                            <div class="stat-title">高级职称教师占比</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewTea(teaStats.gjTeaList)">{{teaStats.gjTeaCountRate}}%</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card :body-style="{ padding: '10px' }">
                            <div class="stat-title">骨干教师占比</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewTea(teaStats.ggTeaList)">{{teaStats.ggTeaCountRate}}%</span>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

                <el-row class="mt10" :gutter="20" style="width: 100%"  >
                    <el-col :span="8">
                        <tea-age-pie-echarts
                          :age1-count="teaStats.age1Count"
                          :age2-count="teaStats.age2Count"
                          :age3-count="teaStats.age3Count"
                          :age4-count="teaStats.age4Count"/>
                    </el-col>
                    <el-col :span="16">
                        <tea-sub-bar-echarts
                          :subject-list="teaSubjectStats.subjectList"
                          :count-list="teaSubjectStats.countList"/>
                    </el-col>
                </el-row>
            </div>
            <!--数据统计 -->
            <el-form ref="queryForm" style="height: 40px" :model="statsQueryForm" :inline="true" label-width="68px">
                <el-row :gutter="20"  style="text-align: left;width: 100%;height: 40px;" >
                    <el-col :span="19"  style="height: 40px">
                        <div  style="padding-left: 10px;font-size: 18px;color: #333;font-weight: bold;">活动数据</div>
                    </el-col>
                    <el-col :span="5" style="height: 40px">
                        <el-form-item label="年份">
                            <el-select v-model="statsQueryForm.yearCode"
                                       @change="statsFormChange"
                                       placeholder="请选择年份">
                                <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 协同备课 -->

<!--            <el-divider><div class="stat-type-title">协同备课</div></el-divider>-->
            <div class="stat-type-title">协同备课</div>
            <div style="padding-bottom: 10px">
                <el-row :gutter="20"  style="width: 100%">
                    <el-col :span="6">
                        <el-card class="first-item" :body-style="{ padding: '10px' }">
                            <div class="stat-title">备课总数</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewLesson(lessonStats.lessonList)">{{lessonStats.totalCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card :body-style="{ padding: '10px' }">
                            <div class="stat-title">协同备课数</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewLesson(lessonStats.teamLessonList)">{{lessonStats.teamCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card :body-style="{ padding: '10px' }">
                            <div class="stat-title">个人备课数</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewLesson(lessonStats.userLessonList)">{{lessonStats.userCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card :body-style="{ padding: '10px' }">
                            <div class="stat-title">参与教师数</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewTeaLesson(lessonStats.teaLessonList)">{{lessonStats.teacherCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

                <el-row class="mt10" :gutter="20" style="width: 100%"  >
                    <el-col :span="8">
                        <totalPieEcharts
                          :id="'2025_lesson'"
                          :title="'备课总数'"
                          :echarts-title="'备课环状统计图'"
                          :totalCount="lessonStats.totalCount"
                          :team-count="lessonStats.teamCount"
                          :user-count="lessonStats.userCount"
                          :year-code="statsQueryForm.yearCode"
                          stats-type="prepare_lesson"/>
                    </el-col>
                    <el-col :span="16">
                        <subBarEcharts
                          :id="'2025_subject'"
                          :subject-list="lessonSubjectStats.subjectList"
                          :count-list="lessonSubjectStats.countList"
                          :yearCode="statsQueryForm.yearCode"
                          echartsTitle="备课总次数分学科统计"/>
                    </el-col>
                </el-row>

                <el-row class="mt20" :gutter="20" style="width: 100%">
                    <el-col :span="24" class="first-item">
                        <yearLineEcharts
                          :id="'teaching_year_lesson'"
                          echartsTitle="协同备课"
                          :month-list="lessonMonthStats.monthList"
                          :one-count-list="lessonMonthStats.oneCountList"
                          :two-count-list="lessonMonthStats.twoCountList"
                          :yearCode="statsQueryForm.yearCode"
                          stats-type="prepare_lesson"/>
                    </el-col>
                </el-row>
            </div>

            <!-- 听评课 -->
            <div class="stat-type-title">听评课</div>
            <div style="padding-bottom: 10px">
                <el-row :gutter="20" class="mt10" style="width: 100%">
                    <el-col :span="6">
                        <el-card class="first-item" :body-style="{ padding: '10px' }">
                            <div class="stat-title">听评课总数</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewEvaLesson(evaStats.lessonList)">{{evaStats.totalCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card  :body-style="{ padding: '10px' }">
                            <div class="stat-title">线上听评</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewEvaLesson(evaStats.onlineLessonList)">{{evaStats.onlineCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card  :body-style="{ padding: '10px' }">
                            <div class="stat-title">推门听评</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewEvaLesson(evaStats.offlineLessonList)">{{evaStats.offlineCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card  :body-style="{ padding: '10px' }">
                            <div class="stat-title">参与教师</div>
                            <div class="stat-count">
                                <span class="stat-count-span" @click="viewTeaEvaLesson(evaStats.teaLessonList)">{{evaStats.teacherCount}}</span>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

                <el-row class="mt10" :gutter="20" style="width: 100%">
                    <el-col :span="8">
                        <eva-total-pie-echarts
                          :id="'2025_eva'"
                          title="听评课总数"
                          echartsTitle="教师听评课环状统计图"
                          :totalCount="evaStats.totalCount"
                          :online-count="evaStats.onlineCount"
                          :offline-count="evaStats.offlineCount"
                          :yearCode="statsQueryForm.yearCode"
                          stats-type="eva_lesson"/>
                    </el-col>
                    <el-col :span="16">
                        <eva-sub-bar-echarts
                          :id="'2025_eva_subject'"
                          :subject-list="evaSubjectStats.subjectList"
                          :count-list="evaSubjectStats.countList"
                          :yearCode="statsQueryForm.yearCode"
                          echartsTitle="教师听评课学科分布图"/>
                    </el-col>
                </el-row>

                <el-row class="mt20" :gutter="20" style="width: 100%">
                    <el-col :span="24" class="first-item">
                        <eva-year-line-echarts
                          :id="'eva_year_lesson'"
                          echartsTitle="听评课"
                          :month-list="evaMonthStats.monthList"
                          :one-count-list="evaMonthStats.oneCountList"
                          :two-count-list="evaMonthStats.twoCountList"
                          :yearCode="statsQueryForm.yearCode"
                          stats-type="eva_lesson"/>
                    </el-col>
                </el-row>
            </div>

        </div>

        <!--备课列表-->
        <el-dialog title="备课列表" v-model="isLessonShow" width="680px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="tableLessonList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="" label="备课标题" prop="title">
                    <template #default="scope">
                        <div :title="scope.row.title" style="color: #409efe;" class="text-one cursor"
                             @click="goDetail(scope.row)">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="80" align="center" label="主备人" prop="trueName">
                </el-table-column>
                <el-table-column width="90" align="center" label="等级" prop="lessonLevelName">
                </el-table-column>
                <el-table-column width="180" align="center" label="所属组织" prop="orgName">
                </el-table-column>

            </el-table>
        </el-dialog>

        <!--备课教师统计-->
        <el-dialog title="教师备课统计" v-model="isTeaLessonShow" width="640px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="teaStatsList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="120" align="center" label="教师姓名" prop="trueName">
                </el-table-column>
                <el-table-column width="145" align="center" label="教师账号" prop="username">
                </el-table-column>
                <el-table-column width="80" align="center" label="主备数" prop="leadCount">
                </el-table-column>
                <el-table-column width="80" align="center" label="协备数" prop="teamCount">
                </el-table-column>
                <el-table-column width="120" align="center" label="个人备课数" prop="personCount">
                </el-table-column>
            </el-table>
        </el-dialog>

        <!--听评课列表-->
        <el-dialog title="听评课列表" v-model="isEvaLessonShow" width="680px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="tableEvaLessonList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="" label="听评课标题" prop="title">
                    <template #default="scope">
                        <div :title="scope.row.title" style="color: #409efe;" class="text-one cursor"
                             @click="goDetail(scope.row)">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="授课教师" prop="trueName">
                </el-table-column>
                <el-table-column width="180" align="center" label="所属组织" prop="orgName">
                </el-table-column>
            </el-table>
        </el-dialog>

        <!--听评课教师统计-->
        <el-dialog title="教师听评课统计" v-model="isTeaEvaLessonShow" width="600px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="teaEvaStatsList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="120" align="center" label="教师姓名" prop="trueName">
                </el-table-column>
                <el-table-column width="145" align="center" label="教师账号" prop="username">
                </el-table-column>
                <el-table-column width="80" align="center" label="授课数" prop="lectureCount">
                </el-table-column>
                <el-table-column width="80" align="center" label="听课数" prop="listenCount">
                </el-table-column>
                <el-table-column width="80" align="center" label="评课数" prop="rateCount">
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="教师信息" v-model="isTeaListShow" width="600px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="tableTeaList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="120" align="center" label="教师姓名" prop="trueName">
                </el-table-column>
                <el-table-column width="145" align="center" label="教师账号" prop="username">
                </el-table-column>
                <el-table-column width="80" align="center" label="学段" prop="periodName">
                </el-table-column>
                <el-table-column width="150" align="center" label="学科" prop="subjectName">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import totalPieEcharts from "@/components/echart/totalPieEcharts";
import subBarEcharts from "@/components/echart/subBarEcharts";
import yearLineEcharts from "@/components/echart/yearLineEcharts";

import evaTotalPieEcharts from "@/components/echart/evaTotalPieEcharts";
import evaSubBarEcharts from "@/components/echart/evaSubBarEcharts";
import evaYearLineEcharts from "@/components/echart/evaYearLineEcharts";

import teaAgePieEcharts from "@/components/echart/teaAgePieEcharts.vue";
import teaSubBarEcharts from "@/components/echart/teaSubBarEcharts.vue";
import { statsPrepareLesson,statsEvaLesson,statsTeacherProfile} from "@/api/admin/stats"
import {timestampToTime} from "@/utils/date";
import {orgListUserSchool} from "@/api/admin/public";

export default {
    name: "statDashboard",
    components: {totalPieEcharts,subBarEcharts,yearLineEcharts,evaTotalPieEcharts,evaSubBarEcharts,evaYearLineEcharts,teaAgePieEcharts,teaSubBarEcharts},
    data() {
        return {
            timestampToTime,
            loading: true,
            isLessonShow:false,
            isEvaLessonShow:false,
            isTeaLessonShow:false,
            isTeaEvaLessonShow:false,
            isTeaListShow:false,
            activeType: '协同备课',
            statsQueryForm:{
                yearCode:'2025',
                orgId:'',
                beginTime:null,
                endTime:null,
                userRole:this.$storage.get("role"),
            },
            yearList: [
                { name: '2025年', value: 2025 },
                { name: '2024年', value: 2024 },
                { name: '2023年', value: 2023 },
            ],
            schoolList: [],
            schoolId:"",
            schoolName:"",
            //协同备课
            lessonStats:{}, //协同备课
            lessonSubjectStats:{},
            lessonMonthStats:{},
            teaStatsList:[],
            tableLessonList:[],
            //听评课
            evaStats:{}, //听评课
            evaSubjectStats:{},
            evaMonthStats:{},
            teaEvaStatsList:[],
            tableEvaLessonList:[],
            //师资统计
            teaStats:{},
            tableTeaList:[],
            teaSubjectStats:{},
        };
    },
    created() {
        this.getSchoolList();

    },
    mounted() {},
    activated() {},
    computed:{
        timestamp(){
            return new Date().getTime();
        }
    },
    methods: {
        getSchoolList() {
            orgListUserSchool().then(res => {
                if (res.data.code == 1){
                    this.schoolList = res.data.data;
                    this.schoolName = this.schoolList[0].orgName;
                    this.schoolId = this.schoolList[0].orgId;
                    this.statsQueryForm.orgId = this.schoolList[0].orgId;
                    this.prepareLessonStats();
                    this.evaLessonStats();
                    this.teacherProfileStats();
                }
            })
        },
        prepareLessonStats(){
            statsPrepareLesson(this.statsQueryForm).then(res => {
                if (res.data.code == 1){
                    this.lessonStats = res.data.data;
                    this.lessonSubjectStats = this.lessonStats.subjectStat;
                    this.lessonMonthStats = this.lessonStats.monthStat;
                }
            })
        },
        viewLesson(lessonList){
            this.tableLessonList = lessonList;
            this.isLessonShow = true;
        },
        viewTeaLesson(list){
            this.teaStatsList = list;
            this.isTeaLessonShow = true;
        },
        statsFormChange(item){
            this.schoolList.forEach(e => {
                if (e.orgId==item){
                    this.schoolId=item;
                    this.schoolName=e.orgName;
                }
            })
            this.prepareLessonStats();
            this.evaLessonStats();
            this.teacherProfileStats();
        },
        evaLessonStats(){
            statsEvaLesson(this.statsQueryForm).then(res => {
                if (res.data.code == 1){
                    this.evaStats = res.data.data;
                    this.evaSubjectStats = this.evaStats.subjectStat;
                    this.evaMonthStats = this.evaStats.monthStat;
                }
            })
        },
        viewEvaLesson(lessonList){
            this.tableEvaLessonList = lessonList;
            this.isEvaLessonShow = true;
        },
        viewTeaEvaLesson(list){
            this.teaEvaStatsList = list;
            this.isTeaEvaLessonShow = true;
        },
        changeSchool(item){
            this.schoolName = item.orgName;
            this.schoolId = item.orgId;
            this.statsQueryForm.orgId = item.orgId;
            this.prepareLessonStats();
            this.evaLessonStats();
            this.teacherProfileStats();
        },
        teacherProfileStats(){
            statsTeacherProfile({orgId:this.statsQueryForm.orgId}).then(res => {
                if (res.data.code == 1){
                    this.teaStats = res.data.data;
                    this.teaSubjectStats = this.teaStats.subjectStat;
                }
            })
        },
        viewTea(list){
            this.tableTeaList = list;
            this.isTeaListShow = true;
        },
    }
};
</script>
<style scoped>
.stat-container{
    width: 100%;
    height: auto;
}
.stat-scrollbar{
    height: calc(100vh - 10px);
    width: 100%;
    padding: 10px 10px 10px 10px;
    background-color: #FFFFFF;
    overflow-x: hidden!important;
    box-sizing: border-box;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
.stat-scrollbar::-webkit-scrollbar {
    display: none;
}

.border-container{
    width: 100%;
    height: 50px;
    display: flex;
}
.school-title{
    font-size: 20px;
    font-weight: bold;
    height: 50px;
    width: auto;
    line-height: 40px;
    color: #4f46e4;
}
.school-content{
    font-size: 15px;
    height: 50px;
    width: auto;
    line-height: 40px;
    color: #999999;
    text-indent: 10px;
}
.school-sel{
    padding-right: 30px;
    box-sizing: border-box;
}
.flex-item:last-child{
    margin-left: auto;
}
.first-item{
    //padding: 10px 10px 10px 0;
    margin-left: 10px;
}
.stat-title{
    height: 40px;
    line-height: 40px;
    color: #333;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
}
.stat-count{
    height: 30px;
    line-height: 20px;
    color: #333333;
    font-weight: bold;
    text-align: center;
}
.stat-count-span{
    color: green;
    cursor: pointer;
    text-decoration: underline;
}

.stat-type-title{
    height: 30px;
    font-size: 18px;
    //background-color: #ff7f2e;
    //color: #fff;
    color: #4f46e4;
    border-radius: 5px;
    box-sizing: border-box;
    font-weight: bold;
    line-height: 30px;
    width: 100px;
    //text-align: center;
    margin-bottom: 10px;
    text-indent: 10px;
}
</style>
